import { sample } from 'effector';

import { Lens } from 'monocle-ts';

import { setIsOpenLogin } from '@stores/dialogs';

import { applyLensPayload } from '@utils/lens';

import { loginActionDomain } from './domain';
import { initialLoginActionState, LoginActionState } from './init';

export const setLoginAction = loginActionDomain.createEvent<LoginActionState['effect']>();

const effectLens = Lens.fromProp<LoginActionState>()('effect');

export const $loginAction = loginActionDomain
    .createStore<LoginActionState>(initialLoginActionState)
    .on(setLoginAction, applyLensPayload(effectLens));

sample({
    clock: setIsOpenLogin,
    filter: (isOpen) => !isOpen,
    fn: () => null,
    target: setLoginAction,
});
